import * as React from "react";
import {
  Outlet,
} from "react-router";
import { CustomFormProvider } from "@/component/CustomFormProvider";

import InitData from "./InitData";



const PrivateLayout = () => {
    return (<InitData><CustomFormProvider><Outlet /></CustomFormProvider></InitData>);
}

export default PrivateLayout;